var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"publishing_standard"},[_vm._m(0),_c('a-button',{nativeOn:{"click":function($event){$event.stopPropagation();return _vm.submit.apply(null, arguments)}}},[_vm._v("查看更多")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"tips"},[_vm._v("为更好的服务于会员单位，中国电力规划设计协会现全文公开已经发布的团体标准。")])])
}]

export { render, staticRenderFns }